import { render, staticRenderFns } from "./146.vue?vue&type=template&id=4c1dc0bb&scoped=true&"
import script from "./146.vue?vue&type=script&lang=js&"
export * from "./146.vue?vue&type=script&lang=js&"
import style0 from "./146.vue?vue&type=style&index=0&id=4c1dc0bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc0bb",
  null
  
)

export default component.exports